import {
  useAssemblyImageCaptionMutation,
  GetAssemblyDetailsDocument,
} from '@/__generated__/graphql';

export function useAssemblyAttachmentCaption() {
  const [assemblyImageCaption, { data, loading, error }] = useAssemblyImageCaptionMutation();

  const updateAssemblyAttachmentCaption = async (
    assemblyId: string,
    assemblyAttachmentId: string,
    caption: string
  ) => {
    return assemblyImageCaption({
      variables: {
        input: {
          assemblyId,
          assemblyAttachmentId,
          caption,
          lastModifiedFor: 'Update attachment caption',
        },
      },
      refetchQueries: [GetAssemblyDetailsDocument],
    }); 
  };

  return { updateAssemblyAttachmentCaption, data, loading, error };
}
